document.addEventListener('DOMContentLoaded', function(){
  const els = document.querySelectorAll('.reveal');
  if (!('IntersectionObserver' in window)) {
    els.forEach(el => el.classList.add('visible'));
    return;
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  els.forEach(el => observer.observe(el));
});
// BIO TOGGLE
document.querySelectorAll(".bio-toggle").forEach(btn => {
  btn.addEventListener("click", function () {
    const card = this.closest(".terrain-leader-card");
    const shortBio = card.querySelector(".short");
    const fullBio = card.querySelector(".full");

    if (fullBio.style.display === "block") {
      fullBio.style.display = "none";
      shortBio.style.display = "block";
      this.textContent = "Read More";
    } else {
      fullBio.style.display = "block";
      shortBio.style.display = "none";
      this.textContent = "Show Less";
    }
  });
});
// SCROLL FADE
const faders = document.querySelectorAll(".fade-up");

const appearOptions = {
  threshold: 0.2
};

const appearOnScroll = new IntersectionObserver(function(entries, observer) {
  entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    entry.target.classList.add("visible");
    observer.unobserve(entry.target);
  });
}, appearOptions);

faders.forEach(fader => {
  appearOnScroll.observe(fader);
});